import { Component, inject } from '@angular/core';
import { FilterService } from '../services/filter.service';
import { map, Observable } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'pf-filter-button',
    templateUrl: './filter-button.component.html',
    styleUrl: './filter-button.component.scss',
    standalone: false,
})
export class FilterButtonComponent {
    protected filterService = inject(FilterService);

    appliedFiltersCount$ = this.filterService.appliedFiltersCount$;
    appliedFilterNames$: Observable<string> =
        this.filterService.filteredKeysNames$.pipe(
            untilDestroyed(this),
            map(filterKeys =>
                filterKeys.length
                    ? 'Filters Applied: ' + filterKeys.join(', ')
                    : 'No filters applied'
            )
        );

    toggleFilter() {
        if (!this.filterService.filtersDisplayed) {
            this.filterService.toggleFilterDisplay();
        } else {
            this.filterService.applyFilters(true);
        }
    }
}
